import api from "../../../core/api";
import {
  CreateReviewRequest,
  ServiceReview,
  CustomerReviewSummary,
  ReviewCheck,
  ReviewListResponse,
} from "../models/reviewModels";

const getRequestConfig = () => {
  return { baseURL: (window as any).app.config.servicingApiBaseUrl };
};

class ServiceReviewsApi {
  createReview(data: CreateReviewRequest): Promise<ServiceReview> {
    return api
      .post<ServiceReview>("/v1/customer/reviews", data, getRequestConfig())
      .then((x) => x.data);
  }

  getReviewsForServiceRequest(
    serviceRequestId: string
  ): Promise<ServiceReview[]> {
    return api
      .get<ServiceReview[]>(
        `/v1/customer/reviews/service-request/${serviceRequestId}`,
        getRequestConfig()
      )
      .then((x) => x.data);
  }

  getReviewSummary(customerId: string): Promise<CustomerReviewSummary> {
    return api
      .get<CustomerReviewSummary>(
        `/v1/customer/reviews/company/${customerId}`,
        getRequestConfig()
      )
      .then((x) => x.data);
  }

  getReviewsList(
    customerId: string,
    page: number = 1,
    pageSize: number = 10
  ): Promise<ReviewListResponse> {
    return api
      .get<ReviewListResponse>(
        `/v1/customer/reviews/company/${customerId}/list?page=${page}&pageSize=${pageSize}`,
        getRequestConfig()
      )
      .then((x) => x.data);
  }

  checkHasReviewed(serviceRequestId: string): Promise<ReviewCheck> {
    return api
      .get<ReviewCheck>(
        `/v1/customer/reviews/check/${serviceRequestId}`,
        getRequestConfig()
      )
      .then((x) => x.data);
  }
}

export default new ServiceReviewsApi();
